import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React from 'react'
import useStyles from './_styles/commonLoaderBackdropStyles'
import { CommonLoaderBackdropProps } from './_props/CommonLoaderBackdropProps'

const CommonLoaderBackdrop: React.FC<CommonLoaderBackdropProps> = ({
    open,
    label = 'Chargement...',
    progressSize = '4.5rem',
}) => {
    const classes = useStyles()

    const computedLabel = label.substring(label.length - 3) === '...' ? label : `${label}...`

    return (
        <Backdrop className={classes.CommonLoaderBackdrop} open={open}>
            <div className={classes.CommonLoaderBackdropContent}>
                <CircularProgress size={progressSize} className={classes.CommonLoaderBackdropLoader} />
                <Typography className={classes.CommonLoaderBackdropMessage}>{computedLabel}</Typography>
            </div>
        </Backdrop>
    )
}

export default CommonLoaderBackdrop
